import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { DirectionControllerService } from "../../services";

// Hook to get all directions
export const useGetAllDirections = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_DIRECTIONS];

  const query = useQuery(queryKey, () =>
    handleRequest(
      DirectionControllerService.directionControllerGetAllDirections()
    )
  );

  return {
    ...query,
  };
};
